module.exports = __webpack_public_path__ + "img/DT100T.3166713a.jpg";